export default "__VITE_ASSET__d258c379__"